import { Card } from '@te-whatu-ora/anatomic'
import { PropsWithChildren, type ReactNode } from 'react'
import { Loader } from '@/components/loader'
import { getTheme } from '@/lib/theme'

interface ContentLoaderProps extends PropsWithChildren {
  loadingMessage?: string
  state: 'loading' | string
}

export default function ContentLoader({
  children,
  loadingMessage = 'Loading',
  state
}: ContentLoaderProps): ReactNode {
  const theme = getTheme()
  if (state === 'loading') {
    if (theme === 'clinical') {
      return (
        <div className='flex items-center justify-center p-4'>
          <Loader message={loadingMessage} />
        </div>
      )
    }

    return (
      <Card>
        <Loader message={loadingMessage} />
      </Card>
    )
  }

  return children
}
